import { startSigningExternal } from "@/orval/gen"
import { Center, Text } from "@mantine/core"
import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/contract-signing/$contractId/")({
  validateSearch: (search: { workflowId: number; envelopeId: string }) =>
    search,
  loaderDeps: ({ search: { workflowId, envelopeId } }) => ({
    workflowId,
    envelopeId,
  }),
  loader: async ({
    deps: { workflowId, envelopeId },
    params: { contractId },
  }) => {
    const recipientUrl = await startSigningExternal({
      contractId: parseInt(contractId),
      workflowId,
      envelopeId,
    })
    location.href = recipientUrl
  },
  pendingComponent: RouteComponent,
})

function RouteComponent() {
  return (
    <Center h={"100%"}>
      <Text>Sie werden zu Docusign weitergeleitet...</Text>
    </Center>
  )
}
